import * as Yup from 'yup'
import { REJECT_REASON } from 'domains/merchant-inbound-item-reject/constants'

const MerchantInboundItemAcceptRejectSchema = Yup.object().shape({
  quantity_received : Yup.number().positive('Must be more than 0').required('Required'),
  quantity_accepted : Yup.number().min(0,'Must be positive').required('Required'),
  rejected_items    : Yup.array()
    .of(
      Yup.object().shape({
        reject_reason: Yup.string().oneOf(Object.values(REJECT_REASON),'invalid Reject Reason')
          .required('reject_reason required')
      }))
})

export default MerchantInboundItemAcceptRejectSchema
